import React from 'react'
import { withSnackbar } from 'notistack'
import Dialog from '@material-ui/core/Dialog'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'

import ChatStudentProfilePage from './ChatStudentProfilePage'

const Services = require('../../RemoteServices/RemoteServices.js')


class ChatStudent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            open: true,
            showDelieveredAmount: false,
            showCurrentLessonUpdate: false,
            showAssignmentVisibilityUpdate: false,
            showCreateNotifications: false,
            historyData: [],
            studentDetails: {
                current_lesson: {
                    title: ''
                }
            },
            studentDetailsNew: {},
            studentId: this.props?.studentData,
            assignmentImages: [],
            imagesModal: false,
            referralListModal: false,
            followListModal: false,
            followList: [],
            followListNext: '',
            followListPrevious: '',
            followTableTitle: '',
            pageLoading: true,
            noteDetail: [],
            paymentHistory: false,
            historyDetail: false,
            studentHistoryData: '',
            promoCode: '',
            promoCodeDetails: [],
            showRemarks: false,
            assignmentRemarks: ''
        }
        this.openImagesInNewTab = this.openImagesInNewTab.bind(this)
    }


    async componentDidMount() {
        // await this.getAssignmentHistory()
        await this.getDetails()
        // await this.getStudentNotesDetail()
        // await this.getPromoCodeDetail()
    }




    async getAssignmentHistory() {
        const userId = this.props.studentData
       //console.log(userId)
        Services.getAssignmentListHistory(userId).then((response) => {
            this.setState({ historyData: response.results.reverse() })
        })
        await this.getDetails()
    }

    async getDetails() {
        const userId = this.props.studentData
       //console.log(this.props.studentData)
        await Services.getStudentsDetails(userId).then((response) => {
            this.setState({ studentDetails: response, pageLoading: false })
        }).catch((error)=>{
            this.setState({pageLoading:false})
        })
    }

    getStudentNotesDetail = async (id) => {
        const userId = id ? id : this.props.studentData
        await Services.getStudentNotes(userId).then((response) => {
            this.setState({ noteDetail: response.results })
        })
    }

    getPromoCodeDetail = async (id) => {
        const userId = id ? id : this.props.studentData
        await Services.getPromoCode(userId).then((response) => {
            this.setState((prevState) => ({
                ...prevState,
                promoCodeDetails: response
            }))
        }).catch((e) => {
            console.log('asdf', e)
        })
    }

    async openImagesInNewTab() {
       //console.log('reached here', this.state.selectedRow)
        const images = []
        if (this.state.selectedRow) {
            let userAssignmentImages = this.state.selectedRow.images
            userAssignmentImages.forEach((image) => {
                images.push({ src: image.image, alt: '' })
                // window.open(image.image, "_blank")
            })
            this.setState({ assignmentImages: images })
            this.setState({ imagesModal: true })
           //console.log(this.state.assignmentImages)
        }
    }

    async setRowData(rowData) {
        await this.setState({ selectedRow: rowData })
        await this.openImagesInNewTab()
    }

    toggleState = state => {
        this.setState({
            [state]: !this.state[state]
        })
    }

    render() {
        const data = this.state.studentDetails

        return (this.state.pageLoading ?
            <> Loading </> :
            <>
                <div>

                    <Dialog fullWidth
                        maxWidth="lg" open={this.state.open} onClose={() => {
                            this.props.closePanel()
                        }} TransitionComponent={this.Transition}>

                        <AppBar color='info' style={{ position: 'relative' }}>
                            <Toolbar>
                               
                                <Typography variant='h6' style={{
                                    marginLeft: 20,
                                    flex: 1
                                }}>
                                    <h2>User Details</h2>
                                </Typography>
                                <IconButton edge='start' color='inherit' onClick={() => {
                                    this.props.closePanel()
                                }} aria-label='close'>
                                    <CloseIcon />
                                </IconButton>
                                {/* <Button color='primary' type='button' onClick={() => {
                                    // this.props.closePanel()
                                    this.setState({ showCreateNotifications: true })
                                }}>
                                    SEND SMS / NOTIFICATION / E-MAIL
                                </Button> */}
                            </Toolbar>
                        </AppBar>


                        <ChatStudentProfilePage userId={data.new_id} />
                    </Dialog>
                </div>

            </>
        )
    }
}

export default withSnackbar(ChatStudent)